import { useEffect, useState } from "react";
import styles from "../dashboard.module.css";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { DashCardLoaderSmall } from "../../../../components/LoaderC";

const DeviceStatutes = ({ selectedProperty }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [requestData, setRequestData] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);

    useEffect(() => {
        const fetchData = async (pId) => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            if (pId > 0) {
                await axios.get(process.env.REACT_APP_USER_API_URL + "v1/dashboard/get-devices-status/" + pId, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    setContentLoading(false);
                    setRequestData(response.data.data);
                }).catch((error) => {
                    setContentLoading(false);
                    setRequestData(null);
                });
            } else {
                await axios.get(process.env.REACT_APP_USER_API_URL + "v1/dashboard/get-devices-status", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }).then((response) => {
                    setContentLoading(false);
                    setRequestData(response.data.data);
                }).catch((error) => {
                    setContentLoading(false);
                    setRequestData(null);
                });
            }
        }

        if (selectedProperty > 0) {
            fetchData(selectedProperty);
        } else {
            fetchData(0);
        }
    }, [selectedProperty, getAccessTokenSilently]);

    return (<div className={`${styles.ScoreCards}`}>
        {contentLoading && (<div className={`${styles.LoaderDash3}`}>
            <div><DashCardLoaderSmall /></div>
        </div>)}

        {!contentLoading && (<div className={`${styles.ScoreCardsFull}`}>
            <div className={`${styles.ScoreCardsUnder}`}>
                <div className={`${styles.ScoreCardConTwo}`}>
                    <div className={`${styles.ScoreCardDevice}`}>
                        <p className={`${styles.OnlineDText}`}>{requestData ? requestData?.online_percentage : 0}%</p>
                        <p className={`${styles.DeviceStatusText}`}>{requestData ? requestData?.online : 0} Online Devices</p>
                    </div>
                    <div className={`${styles.ScoreCardDevice}`}>
                        <p className={`${styles.OfflineDText}`}>{requestData ? requestData?.offline_percentage : 0}%</p>
                        <p className={`${styles.DeviceStatusText}`}>{requestData ? requestData?.offline : 0} Offline Devices</p>
                    </div>
                </div>
            </div>
        </div>)}
    </div>);
}

export default DeviceStatutes;